import { decodeString, encodeString } from 'root/utils/string/encoding';

const lsPrefix = 'ls';

function saveEncodedValueToSessionStorage(
    key: string,
    value: string,
    prefix: string = lsPrefix
) {
    (<any>window).registerCookieComplianceCallback({
        callback: () =>
            window.sessionStorage.setItem(`${prefix}.${key}`, encodeString(value)),
        category: 'functional',
        isCallOptanonWrapper: true,
    });
}

function removeKeyFromSessionStorage(key: string, prefix: string = lsPrefix) {
    window.sessionStorage.removeItem(`${prefix}.${key}`);
}

function getDecodedValueFromSessionStorage(key: string, prefix: string = lsPrefix) {
    const sessionStorageValue =
        window && navigator.cookieEnabled
            ? window.sessionStorage.getItem(`${prefix}.${key}`)
            : null;
    return sessionStorageValue ? decodeString(sessionStorageValue) : null;
}

export {
    saveEncodedValueToSessionStorage,
    removeKeyFromSessionStorage,
    getDecodedValueFromSessionStorage,
};
